export default "__VITE_PUBLIC_ASSET__29fa5091__"